var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 17.0127C6.66663 15.2024 6.66663 14.2972 7.03257 13.5016C7.39852 12.7059 8.08578 12.1168 9.4603 10.9387L10.7936 9.79582C13.2781 7.66632 14.5203 6.60156 16 6.60156C17.4797 6.60156 18.7219 7.66631 21.2063 9.79582L22.5396 10.9387C23.9141 12.1168 24.6014 12.7059 24.9673 13.5016C25.3333 14.2972 25.3333 15.2024 25.3333 17.0127V22.6666C25.3333 25.1807 25.3333 26.4378 24.5522 27.2189C23.7712 27.9999 22.5141 27.9999 20 27.9999H12C9.4858 27.9999 8.22872 27.9999 7.44767 27.2189C6.66663 26.4378 6.66663 25.1807 6.66663 22.6666V17.0127Z",
    fill: "#0E1596",
    stroke: "#0E1596",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 28V21C19.3333 20.4477 18.8856 20 18.3333 20H13.6666C13.1143 20 12.6666 20.4477 12.6666 21V28",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFilled);
export default __webpack_public_path__ + "static/media/home-filled.5641731f83ceba746a8f25197e4b68bf.svg";
export { ForwardRef as ReactComponent };